import { ActionItem, Box, Text } from '@factorialco/deprecated-design-system'

import Date from 'modules/core/components/Date'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { stringToDate } from 'modules/core/lib/dates'

import type CompanyHoliday from 'modules/timeoff/store/models/CompanyHoliday'

interface Props {
  holiday: CompanyHoliday
  locationId: number
}

const Holiday = ({ holiday, locationId }: Props) => {
  const { navigation } = useNavigation()
  const date = stringToDate(holiday.attributes.date, 'backend')
  const url = navigation.settings.locations.locationsId.holidays.editHolidayId.fullPath({
    id: locationId,
    holidayId: holiday.attributes.id,
  })

  return (
    <Box
      width="full"
      border={{
        top: {
          color: 'grey400',
          width: 's1',
          style: 'solid',
        },
      }}
    >
      <ActionItem to={url} transparent>
        <Box flexDirection="row" alignItems="center" width="full">
          <Box>
            <Date date={date} />
          </Box>
          <Box paddingLeft="s16" overflowX="hidden">
            <Text color="grey1000" size="300" ellipsis>
              {holiday.attributes.summary}
            </Text>
          </Box>
        </Box>
      </ActionItem>
    </Box>
  )
}

export default Holiday
